import {useEffect, useState} from "react";
import {useParams} from "react-router";
import {
    addInventoryToCart,
    getPurchaseOrder,
    getPurchaseOrderLines,
    insertPurchaseOrderLineItem,
    createInvoice,
    deletePurchaseOrderLineItem,
    getPurchaseOrderTask,
    insertPurchaseOrderTask, getBuyer, updatePurchaseOrderLineQuantity, updatePurchaseOrderNotes, insertInvoiceLineItems
} from "../../api/Api";
import {Button, Card, Collapse, Divider, Row, Col, Input, Popover, message} from "antd";
import {toFSDate} from "../../util/timeutils";
import {PurchaseOrderStateWidget} from "../sales/PurchaseOrderStateWidget";
import {PurchaseOrderLineItemTable} from "../sales/PurchaseOrderLineItemTable";
import {ProductQuantitySelectWidget} from "../inventory/ProductQuantitySelectWidget";
import {isFulfillment} from "../../auth/sessionTools";
import {PurchaseOrderStatusType} from "../../api/Constants";
import {SimpleTaskTable} from "../sales/SimpleTaskTable";
import {NewTask} from "../tasks/NewTask";
import {BuyerInvoiceProfile} from "../sales/BuyerInvoiceProfile";
import {NewPOLaborWidget} from "./NewPOLaborWidget";
import {POLaborTable} from "./POLaborTable";

const {TextArea} = Input;

export const PurchaseOrderView = ({session, onApiFail, refresh, onRefresh, props}) => {
    const [purchaseOrder, setPurchaseOrder] = useState(undefined);
    const [poLines, setPoLines] = useState([]);
    const [poAssigns, setPoAssigns] = useState({});
    const [tasks, setTasks] = useState([]);
    const [product, setProduct] = useState(undefined);
    const [quantity, setQuantity] = useState(undefined);
    const [messageApi, contextHolder] = message.useMessage();
    const [invoiceCreated, setInvoiceCreated] = useState(false);
    const [buyer, setBuyer] = useState(undefined);
    const [notes, setNotes] = useState("")
    const [notesChanged, setNotesChanged] = useState(false);

    const params = useParams();
    const purchaseId = params.purchaseId;

    const isFulfillmentDepartment = isFulfillment(session);
    const io = {refresh, onRefresh, onApiFail};


    useEffect(() => {
        if (purchaseId === undefined) {
            return;
        }
        getPurchaseOrder(purchaseId).then(result => {
            setPurchaseOrder(result);

            if (result !== undefined) {
                // setNotes(result.notes);
                return getPurchaseOrderLines(result.id);
            } else {
                return Promise.resolve([]);
            }
        }).then(data => {
            const lines = data.map(l => {
                return {...l, key: l.id}
            })
            setPoLines(lines);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });

        getPurchaseOrderTask(purchaseId).then(r => {
            const taskData = r.map(row => {
                return {
                    ...row,
                    key: row.id
                }
            });
            setTasks(taskData);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [purchaseId, refresh, onApiFail]);

    useEffect(() => {
        if (purchaseOrder === undefined) {
            return;
        }
        if (notesChanged === false) {
            setNotes(purchaseOrder.notes);
        }
    }, [purchaseOrder, notesChanged])

    useEffect(() => {
        if (purchaseOrder === undefined) {
            return;
        }
        getBuyer(purchaseOrder.buyerId).then(b => {
            setBuyer(b);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [purchaseOrder, onApiFail]);

    useEffect(() => {
        // OK this useEffect is a bit hokey 02.02.2026
        // we had to move it here to avoid the timed automatic refresh, every time it refreshed it was
        // making the assigns undefined.   on a really long PO it's impossible to assign everything before
        // the refresh cycles again
        // so this is hokey because we are reading the PO lines again.
        getPurchaseOrderLines(purchaseId).then(data => {
            setPoAssigns({});
        })

    }, [purchaseId])

    const onSaveLineItem = () => {
        // first check to see if there's a duplicate item
        for (let i=0; i<poLines.length; i++) {
            const l = poLines[i];
            if (l.productId === product.id) {
                messageApi.open({
                    type: "error",
                    content: "Duplicate Item"
                });
                return;
            }
        }

        insertPurchaseOrderLineItem(purchaseId, {...product, quantity}).then(r => {
            if (onRefresh) onRefresh();
            setProduct(undefined);
            setQuantity(undefined);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }

    const onSelectAssign = (val, lineId) => {
        const nextAssigns = {...poAssigns};
        // user has picked this inventory
        nextAssigns[lineId] = val.id;
        setPoAssigns(nextAssigns);
    }

    const onCreateInvoice = () => {
        console.log(`create invoice`)
        // we need to test poLines against poAssigns
        let unAssignedError = false;
        poLines.forEach(l => {
            if (poAssigns[l.id] === undefined ) {
                unAssignedError = true;
                console.log(`line at with id ${l.id} is unassigned`);
            }
        });
        if (unAssignedError === true) {
            // some line items are unassigned so we can't proceed
            return;
        }

        // if we are here, everything is assigned, so we'll try to reserve everything to the cart
        const promises = [];
        poLines.forEach(l => {
            promises.push(addInventoryToCart(poAssigns[l.id], l.quantity));
        });

        Promise.all(promises).then(r => {
            // after we reserve to cart create the invoice
            console.log(`creating invoice`);
            return createInvoice(purchaseOrder.buyerId);
        }).then(invoice => {
            const {id} = invoice;

            // invoice items is an object
            const invoiceItems = {};
            poLines.forEach(l => {
                const inventoryId = poAssigns[l.id];
                const quantity = l.quantity;
                invoiceItems[inventoryId] = {
                    quantity,
                    item: {
                        id: inventoryId,
                        discount: 0,
                        lineDiscount: 0,
                        invoicePrice: 0,
                        linePrice: 0,
                    }
                }
            });

            return insertInvoiceLineItems(id, invoiceItems);
        }).then(r => {
            setInvoiceCreated(true);
            messageApi.open({
                type: 'success',
                content: 'Invoice Created'
            });
        }).catch (e => {
            console.log(`create invoice failed ${e}`);
            messageApi.open({
                type: 'error',
                content: 'Failed to Create Invoice'
            });
        });
    }

    const onLineItemDelete = (index, item) => {
        deletePurchaseOrderLineItem(purchaseId, item.id).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }

    const onQuantityChange = (record, quantity) => {
        updatePurchaseOrderLineQuantity(purchaseId, record.id, quantity).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }

    const onNotesChange = (e) => {
        setNotesChanged(true);
        setNotes(e.target.value);
    }

    const onNewTask = (task) => {
        const newTask = [{
            ...task,
            id: task.id
        }]
        insertPurchaseOrderTask(purchaseId, newTask).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }

    const onSaveNotes = () => {
        updatePurchaseOrderNotes(purchaseId, notes).then(r => {
            setNotesChanged(false);
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }

    const collapseItem = [
        {
            key: '1',
            label: <div><Popover content={`Add More Products to this Purchase Order`}><b>Add More Products</b></Popover></div>,
            children: <ProductQuantitySelectWidget product={product} onProductSelect={setProduct} quantity={quantity} onQuantityChange={setQuantity}
                                                   onSave={onSaveLineItem} refresh={refresh} />
        }
    ];

    let lineUnassigned = false;
    poLines.forEach(l => {
        lineUnassigned |= (poAssigns[l.id] === undefined);
    })
    const invoiceDisable = invoiceCreated || lineUnassigned;

    const rowStyle = {
        marginTop: '10px',
        marginBottom: '10px`'
    }

    if (!purchaseOrder) {
        return <div />
    }

    // don't allow line items to be deleted from verified POs
    const lineItemDelete = (purchaseOrder.state < PurchaseOrderStatusType.Verified) ? onLineItemDelete : undefined;

    const purchaseOrderView =  <div style={{textAlign: 'left'}}>
        {contextHolder}
        <Card title={"Purchase Order"}>
            <Row>
                <Col style={{width: 125}}><b>
                    Purchase Order:
                </b>
                </Col>
                <Col>{purchaseOrder.poNumber}</Col>
            </Row>
            <Row>
                <PurchaseOrderStateWidget purchaseOrder={purchaseOrder} onRefresh={onRefresh} onApiFail={onApiFail} isFulfillment={isFulfillmentDepartment}/>
            </Row>
        </Card>
        {buyer !== undefined &&
            <BuyerInvoiceProfile buyer={buyer} />
        }
        <Card title={'Due Date'}>
            <Row>
                <div>{toFSDate(new Date(purchaseOrder.dueDate))}</div>
            </Row>
        </Card><p/>
        <Card title={'Notes'}>
            <Row style={rowStyle}>
                <TextArea maxLength={10240} rows={12} showCount value={notes} onChange={onNotesChange}/>
            </Row>
            <Row style={rowStyle}>
                <Button onClick={onSaveNotes} disabled={notes===purchaseOrder.notes}>Save Changes</Button>
            </Row>
        </Card>
        <Card title={'Labor'}>
            <POLaborTable session={session} purchaseOrder={purchaseOrder} io={io} />
            <Divider />
            <NewPOLaborWidget purchaseOrder={purchaseOrder} io={io}/>
        </Card>
        <Card title={'Tasks'}>
            {tasks.length > 0 &&
                <SimpleTaskTable tasks={tasks} enableLinks={true} />
            }
            <Collapse ghost bordered={false} items={[
                {
                    key: 1,
                    label: <b>Add Tasks</b>,
                    children: <NewTask onApiFail={onApiFail} refresh={refresh} onRefresh={onRefresh} onNewTask={onNewTask} />
                }
            ]}/>
        </Card>
        <Card title={'P.O. Items'}>
            <PurchaseOrderLineItemTable purchaseId={purchaseOrder.id} products={poLines} onSelectAssign={onSelectAssign}
                    onDelete={lineItemDelete} onQuantityChange={onQuantityChange}
                    onApiFail={onApiFail} refresh={refresh} onRefresh={onRefresh} isFulfillment={isFulfillmentDepartment} showLink={true} showState={true} />
            {((purchaseOrder.state <= PurchaseOrderStatusType.Complete)) &&
                <div>
                    <Divider />
                    <Collapse bordered={false} ghost items={collapseItem} />
                </div>
            }
        </Card>
        <Card title={`Invoice Creation`}>
            <Button onClick={onCreateInvoice} disabled={invoiceDisable}>Create Invoice</Button>
        </Card>
    </div>

    return purchaseOrderView;
}